export default __webpack_public_path__ + "static/media/image-work-personal-w@3x.f7363f35.png";